import React, { useState, useEffect } from "react";
import CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";
import Snackbar, { SnackbarOrigin } from "@mui/material/Snackbar";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import MuiCard from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";
import { IMaskInput } from "react-imask";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Link from "@mui/material/Link";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { styled } from "@mui/material/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Collapse from "@mui/material/Collapse";
import ForgotPassword from "./ForgotPassword";
import MessengerInfo from "./MessengerInfo";
import Avatars from "../Avatar/Avatar";
import Checkout from "../SignUp/Checkout";
import { useAuth } from "../Auth/AuthProtecter";
import Backdropcircle from "../Loading/Backdrop";
import OtpInput from "react-otp-input";

const Card = styled(MuiCard)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignSelf: "center",
  width: "100%",
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  boxShadow:
    "hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px",
  [theme.breakpoints.up("sm")]: {
    width: "450px",
  },
}));

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <IMaskInput
      {...other}
      mask="a - 0000000000"
      definitions={{
        a: /^[VGEJPvgejp]/, // Acepta tanto mayúsculas como minúsculas
        "#": /[0-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => {
        // Convierte el primer carácter a mayúscula y el resto permanece igual
        const transformedValue = value.replace(/^([vgejp])/, (match) =>
          match.toUpperCase()
        );
        onChange({ target: { name: props.name, value: transformedValue } });
      }}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

const lst = process.env.REACT_APP_API_SINGIN_LSTOREGE;
const LST = process.env.REACT_APP_API_FRRS_LSTOREGE;
const secretKey = process.env.REACT_APP_SECRET_KEY_LOCALSTORAGE;
const ENDPOIND = process.env.REACT_APP_API_SINGIN;

export default function SignInCard({ ...other }) {
  const auth = useAuth();

  // 1. Estados para validar horario y obtener la hora actual
  const [isAvailable, setIsAvailable] = React.useState(false); // Indica si el sistema está disponible
  const [currentTime, setCurrentTime] = React.useState(""); // Muestra la hora actual

  React.useEffect(() => {
    const validateServerTime = () => {
      // Obtener la hora actual del servidor ajustada a la zona horaria de Venezuela
      const serverTime = new Date(); // Hora del servidor
      const venezuelanTime = new Intl.DateTimeFormat("es-VE", {
        timeZone: "America/Caracas",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: false, // Usar formato de 24 horas
      }).formatToParts(serverTime);

      // Extraer la hora como número
      const currentHour = parseInt(
        venezuelanTime.find((part) => part.type === "hour")?.value,
        10
      );

      setCurrentTime(
        venezuelanTime.map((part) => part.value).join("") // Combina todas las partes (opcional, para mostrar formato completo)
      );

      if (currentHour >= 18 && currentHour < 21) {
        setIsAvailable(true); // Disponible para agendar
      } else {
        setIsAvailable(false); // Fuera del horario
      }
    };

    validateServerTime();
  }, []);

  const [loginUrl, setLoginUrl] = React.useState(auth.Domain);
  const [KeyRecatpchat, setKeyRecatpchat] = React.useState(auth.KeyRecatpchat);

  const [state, setState] = React.useState({
    openn: false,
    vertical: "top",
    horizontal: "center",
  });

  const { vertical, horizontal, openn } = state;

  useEffect(() => {
    const showMessage = () => {
      if (!sessionStorage.getItem("messageClosed")) {
        setState({ ...state, openn: true });
      }
    };

    const interval = setInterval(showMessage, 5 * 1000); // 15 segundos en milisegundos

    return () => clearInterval(interval); // Limpiar el intervalo al desmontar el componente
  }, []);

  const handleClosee = () => {
    setState({ ...state, openn: false });
    sessionStorage.setItem("messageClosed", "true");
    console.log(state);
  };

  const [emailError, setEmailError] = React.useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = React.useState("");
  //
  const [NewValue, setValue] = React.useState("");
  const [documentError, setdocumentError] = React.useState(false);
  const [documentErrorMessage, setdocumentErrorMessage] = React.useState("");
  //
  const [passwordError, setPasswordError] = React.useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = React.useState("");
  const [openPassword, setOpenPassword] = React.useState(false);

  const [open, setOpen] = React.useState(false);
  const [openMessegerInfo, setopenMessegerInfo] = React.useState(true);

  const [checked, setChecked] = React.useState(false);
  const [checked2, setChecked2] = React.useState(false);
  // Messeger
  const [openMesseger, setOpenMesseger] = React.useState("");
  const [Messeger, setMesseger] = React.useState("");
  const [StatusMesseger, setStatusMesseger] = React.useState("");
  //
  const [openProgress, setOpenProgress] = React.useState(false);
  //
  const [checkedUser, setCheckedUser] = React.useState(false);
  //
  const [openBackdropcircle, setOpenBackdropcircle] = React.useState(false);
  //

  const handleChangeCheckbox = (event) => {
    setChecked(event.target.checked);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setopenMessegerInfo(false);
  };

  function onChange(value) {
    setChecked(true);
  }

  const handleSubmit = async (event) => {
    //
    event.preventDefault();
    //
    if (documentError || emailError) {
      event.preventDefault();
      return;
    }
    //////////////////////
    setOpenProgress(true);
    setOpenMesseger(false);
    setChecked(false);
    //---------------
    const data = new FormData(event.currentTarget);
    //
    const document = data.get("document");
    const email = data.get("email");
    const password = data.get("password");
    //
    const datePost = {
      documentid: document ? document.replace(/[\s-]/g, "") : document,
      email: email,
    };
    //
    // Enviar el OTP:
    if (!password) {
      
      //
      try {
        //
        const jsonpass = {
          method: "POST",
          body: JSON.stringify(datePost),
        };
        //
        const respass = await fetch(`${loginUrl}${ENDPOIND}`, jsonpass);
        const res_pass = await respass.json();
        //
        if (respass.status === 200) {
          //
          setMesseger(res_pass.message);
          setStatusMesseger("success");
          setOpenMesseger(true);
          setOpenProgress(false);
          setOpenPassword(true);
          //
          sessionStorage.setItem(lst, JSON.stringify(datePost));
        } else if (respass.status === 400) {
          //
          if (res_pass.status === 1) {
            //
            setMesseger(res_pass.error);
            setStatusMesseger("warning");
            setOpenMesseger(true);
            setOpenProgress(false);
            //
          } else if (res_pass.status === 7) {
            //
            setMesseger(res_pass.error);
            setStatusMesseger("error");
            setOpenMesseger(true);
            setOpenProgress(false);
            //
          } else if (res_pass.status === 8) {
            //
            setMesseger(res_pass.error);
            setStatusMesseger("error");
            setOpenMesseger(true);
            setOpenProgress(false);
            //
          } else if (res_pass.status === 2) {
            setMesseger(res_pass.error);
            setStatusMesseger("success");
            setOpenMesseger(true);
            setOpenProgress(false);
            setOpenPassword(true);
            setChecked(false);
          } else {
            const message = "Usted no esta autorizado para solicitar cita";
            //
            if (message === res_pass.error) {
              setMesseger(res_pass.error);
              setStatusMesseger("error");
              setOpenMesseger(true);
              setOpenProgress(false);
              // setOpenPassword(true);
              setChecked(false);
            } else {
              setMesseger(res_pass.error);
              setStatusMesseger("info");
              setOpenMesseger(true);
              setOpenProgress(false);

            }
            //
          }
          //
          sessionStorage.setItem(lst, JSON.stringify(datePost));
          //
        } else if (respass.status === 500) {
          //
          setMesseger(res_pass.error);
          setStatusMesseger("error");
          setOpenMesseger(true);
          setOpenProgress(false);
          //
        } else {
          setMesseger("Error desconocido #" + respass.status);
          setStatusMesseger("error");
          setOpenMesseger(true);
          setOpenProgress(false);
          //
        }
        //
      } catch (error) {
        //
        console.log(error);
        setMesseger("Error de Conexión, intente nuevamente");
        setStatusMesseger("error");
        setOpenMesseger(true);
        setOpenProgress(false);
        setChecked(true);
        //
      }
    } else {
      //
      const array = JSON.parse(sessionStorage.getItem(lst));
      const updatedValue = { ...array, pass: password };
      //console.log(updatedValue);
      //
      try {
        //
        const jsonpass = {
          method: "POST",
          body: JSON.stringify(updatedValue),
        };

        const respass = await fetch(`${loginUrl}${ENDPOIND}`, jsonpass);
        const res_pass = await respass.json();

        if (respass.status === 200) {
          //
          if (res_pass.status === 5) {
            //
            setOpenBackdropcircle(true);

            window.setTimeout(() => {
              auth.saveUser(res_pass);
              window.location.reload();
            }, 500);
            //
          } else if (res_pass.status === 4) {
            //
            auth.checkAuthUser(res_pass);
            setOpenBackdropcircle(true);
            //
            window.setTimeout(() => {
              setCheckedUser(true);
              other.setCheckedUser(true);
              window.setTimeout(() => {
                setOpenBackdropcircle(false);
              }, 800);
            }, 500);

            const dataPost = {
              documentid: array.documentid,
              email: array.email,
            };
            sessionStorage.setItem(
              LST,
              CryptoJS.AES.encrypt(
                JSON.stringify(dataPost),
                secretKey
              ).toString()
            );
            //
          } else {
            setMesseger("Contacte con atención al cliente.");
            setStatusMesseger("info");
            setOpenMesseger(true);
            setOpenProgress(false);
            setOpenPassword(true);
            setChecked(false);
          }

          sessionStorage.removeItem(lst); // Eliminar el ítem si ha expirado
        } else if (respass.status === 400) {
          //
          if (res_pass.status === 2) {
            setMesseger(res_pass.error);
            setStatusMesseger("error");
            setOpenMesseger(true);
            setOpenProgress(false);
            setOpenPassword(true);
            setChecked(false);
          } else {
            setMesseger(res_pass.error);
            setStatusMesseger("warning");
            setOpenMesseger(true);
            setOpenProgress(false);
            setOpenPassword(true);
            setChecked(false);
          }
          //
        } else if (respass.status === 500) {
          //
          setMesseger("Error interno. Intente más tarde.");
          setStatusMesseger("error");
          setOpenMesseger(true);
          setOpenProgress(false);
          setOpenPassword(true);
          setChecked(false);
          //
        } else {
          //
          setMesseger("Lo sentimos, estamos presentando problemas.");
          setStatusMesseger("error");
          setOpenMesseger(true);
          setOpenProgress(false);
          setOpenPassword(true);
          setChecked(false);
          //
        }
      } catch (error) {
        setMesseger("Error de Conexión, intente nuevamente");
        setStatusMesseger("error");
        setOpenMesseger(true);
        setOpenProgress(false);
        setOpenPassword(true);
        setChecked(true);
      }
    }
  };

  // Validar Datos del Form:
  const validateInputs = (e) => {
    let isValid = true;

    if (checked) {
      const email = document.getElementById("email");
      const documentclient = document.getElementById("document");
      const doctm = documentclient.value.replace(/[\s-]/g, "");
      const regex = /^[vgejpVGEJP]\d{5,10}$/;

      if (!doctm) {
        setdocumentError(true);
        setdocumentErrorMessage(
          "Introduzca un numero de documento iniciando con el tipo de documento: V, E, G, J, P."
        );
        isValid = false;
      } else {
        if (regex.test(doctm)) {
          setdocumentError(false);
          setdocumentErrorMessage("");
        } else {
          setdocumentError(true);          
          if (doctm.length < 5) {
            setdocumentErrorMessage(
              "El numero de documento debe ser mayor a 5 digitos"
            );
          } 
          isValid = false;
        }
      }

      if (!email.value || !/\S+@\S+\.\S+/.test(email.value)) {
        setEmailError(true);
        setEmailErrorMessage(
          "Introduzca una dirección de correo electrónico válida."
        );
        isValid = false;
      } else {
        setEmailError(false);
        setEmailErrorMessage("");
      }
    } else {
      const password = document.getElementById("password");

      if (!password.value || password.value.length < 6) {
        setPasswordError(true);
        setPasswordErrorMessage(
          "La contraseña debe tener al menos 6 caracteres."
        );
        isValid = false;
      } else {
        setPasswordError(false);
        setPasswordErrorMessage("");
      }
    }

    return isValid;
  };
  // Fin de check datos

  const handleChange = (event) => {
    const upperCaseValue = event.target.value.toUpperCase();
    setValue(upperCaseValue);
  };

  const handleChangeOtp = (event) => {
    const value = event.target.value.length;

    if (value === 6) {
      setChecked2(true);
    } else if (value > 6) {
      setChecked2(false);
      setPasswordError(true);
      setPasswordErrorMessage(
        "La contraseña no puede tener más de 6 caracteres"
      );
    } else {
      setChecked2(false);
      setPasswordError(false);
      setPasswordErrorMessage("");
    }
  };
  // Renderizado principal del componente
  return (
    <>
      {/* Renderizar formulario principal si el usuario aún no ha sido validado */}
      <Collapse in={!checkedUser}>
        <Card variant="outlined">
          {/* Muestra el círculo de carga si está habilitado */}
          {openBackdropcircle && <Backdropcircle />}

          {/* Encabezado del formulario con avatar */}
          <Box
            sx={{
              display: { xs: "flex", md: "none" }, // Solo visible en pantallas pequeñas
              flexDirection: "column",
              alignItems: "center", // Centra el contenido horizontalmente
            }}
          >
            <Avatars /> {/* Componente de avatar para el usuario */}
          </Box>

          {/* Título del formulario */}
          <Typography
            component="h4"
            variant="h4"
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              fontSize: "clamp(1rem, 10vw, 1.5rem)", // Tamaño adaptativo del texto
            }}
          >
            Solicitud de citas
          </Typography>

          {/* Contenedor del formulario */}
          <Box
            component="form"
            onSubmit={handleSubmit} // Lógica para manejar el envío del formulario
            noValidate // Desactiva validación automática del navegador
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: 2, // Espacio entre los elementos
            }}
          >
            {/* Letrero dinámico que aparece si el sistema está fuera del horario disponible */}
            <Alert severity="info" sx={{ mb: 2 }}>
              <AlertTitle>Horario de disponibilidad</AlertTitle>
              Agende su cita diariamente a las
              <strong>9:00 p. m.</strong>.
            </Alert>


            {/* Campo: Documento de identidad */}
            <FormControl>
              <FormLabel htmlFor="document">Documento de identidad</FormLabel>
              <TextField
                error={documentError} // Muestra error si hay problemas en la validación
                helperText={documentErrorMessage} // Muestra el mensaje de error específico
                id="document"
                type="document"
                name="document"
                placeholder="V-9999999999" // Formato esperado
                autoComplete="document"
                autoFocus
                required
                fullWidth
                variant="outlined"
                color={documentError ? "error" : "primary"} // Cambia el color según el estado de validación
                sx={{ ariaLabel: "document" }}
                InputProps={{
                  inputComponent: TextMaskCustom, // Máscara personalizada para el documento
                }}
                value={NewValue}
                onChange={handleChange} // Lógica para manejar cambios
                disabled={openPassword} // Bloquear si el sistema está fuera del horario
              />
            </FormControl>

            {/* Campo: Correo electrónico */}
            <FormControl>
              <FormLabel htmlFor="email">Correo electrónico</FormLabel>
              <TextField
                error={emailError} // Indica error en la validación del email
                helperText={emailErrorMessage} // Muestra el mensaje de error para email
                id="email"
                type="email"
                name="email"
                placeholder="correo@email.com" // Formato esperado
                autoComplete="email"
                autoFocus
                required
                fullWidth
                variant="outlined"
                color={emailError ? "error" : "primary"} // Cambia color según el estado
                sx={{ ariaLabel: "email" }}
                disabled={openPassword} // Bloquear si el sistema está fuera del horario
              />
            </FormControl>

            {/* Indicador de progreso durante la carga */}
            {openProgress && <LinearProgress />}

            {/* Mostrar mensaje dinámico cuando se envía el formulario */}
            {openMesseger && (
              <Alert variant="filled" severity={StatusMesseger}>
                <AlertTitle>{Messeger}</AlertTitle>
              </Alert>
            )}

            {/* Campo de OTP para validación */}
            {openPassword ? (
              <>
                <FormControl>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <FormLabel htmlFor="password">Código OTP</FormLabel>
                    <Link
                      component="button"
                      type="button"
                      onClick={handleClickOpen} // Abre el modal para recordar el código OTP
                      variant="body2"
                      sx={{ alignSelf: "baseline" }}
                    >
                      Recordar código
                    </Link>
                  </Box>
                  <TextField
                    error={passwordError} // Indica error en el OTP
                    helperText={passwordErrorMessage} // Muestra el mensaje de error específico
                    name="password"
                    placeholder="••••••"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    autoFocus
                    required
                    fullWidth
                    variant="outlined"
                    color={passwordError ? "error" : "primary"}
                    onChange={handleChangeOtp} // Lógica para validar OTP
                    inputProps={{ maxLength: 6 }} // Limitar la longitud máxima
                  />
                </FormControl>
              </>
            ) : (
              <>
                {/* Checkbox para la validación "Soy un humano" */}
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={handleChangeCheckbox} // Manejo del cambio de estado
                      value="remember"
                      color="primary"
                    />
                  }
                  label="Soy un humano"
                />
                {/* Opción para implementar ReCAPTCHA */}
                {/* <ReCAPTCHA onChange={onChange} sitekey={KeyRecatpchat} /> */}
              </>
            )}

            {/* Botón de envío */}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              onClick={validateInputs} // Validar inputs antes de enviar
              disabled={(!checked && !checked2)} // Bloqueo según el estado de validación y horario
            >
              {openPassword ? "Ingresar" : "Verificar"}
            </Button>

            {/* Componente de recuperación de contraseña */}
            <ForgotPassword
              open={open}
              handleClose={handleClose}
              url={loginUrl}
            />

            {/* Mensaje flotante de advertencia */}
            <Snackbar
              anchorOrigin={{ vertical, horizontal }}
              open={openn}
              key={vertical + horizontal}
            >
              <Alert variant="filled" onClose={handleClosee} severity="warning">
                "Por favor, conserve el código que le hemos enviado a su correo
                electrónico, ya que será necesario para futuros accesos."
              </Alert>
            </Snackbar>
          </Box>
        </Card>
      </Collapse>

      {/* Renderizado del componente `Checkout` si el usuario está validado */}
      {checkedUser && <Collapse in={checkedUser}>{<Checkout />}</Collapse>}
    </>
  );
}
